/** API response format for destination junctions (pagination support). */
export const mockEolDestinationJunctionsLinehaulApiRows = [
  {
    id: 117,
    sequence: 1,
    type: "destination",
    junctionCode: "DAL",
    criteriaId: 91002,
    numberOfGroups: 2,
    numberOfSequences: 2,
    serviceLevels: ["LTL", "LTL-CC", "TRUCKLOAD", "VOLUME"],
    additionalDays: 0,
    status: "Active",
    effectiveDate: "01/01/2026",
    expiryDate: "12/31/2026",
    adjIndicator: true,
    carrierCode: null,
  },
  {
    id: 160,
    sequence: 2,
    type: "destination",
    junctionCode: "HOU",
    serviceLevels: ["LTL"],
    additionalDays: 3,
    status: "Inactive",
    effectiveDate: "01/01/2023",
    expiryDate: "12/31/2099",
    adjIndicator: false,
    carrierCode: null,
  },
  {
    id: 161,
    sequence: 3,
    type: "destination",
    junctionCode: "ATL",
    serviceLevels: ["LTL"],
    additionalDays: 0,
    status: "Active",
    effectiveDate: "01/01/2023",
    expiryDate: "12/31/2099",
    adjIndicator: true,
    carrierCode: null,
  },
  {
    id: 162,
    sequence: 4,
    type: "destination",
    junctionCode: "DFW",
    serviceLevels: ["LTL", "LTL-CC"],
    additionalDays: 1,
    status: "Pending",
    effectiveDate: "01/01/2023",
    expiryDate: "12/31/2099",
    adjIndicator: false,
    carrierCode: null,
  },
];
